import React from 'react';

const NumberInput = ({
  inputValue,
  autoFocus,
  min = 1,
  onKeyDown,
  onBlur,

  setInputValue,
  setInputFocused,
}: {
  inputValue: number;
  autoFocus: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  setInputValue: React.Dispatch<React.SetStateAction<number>>;
  setInputFocused: React.Dispatch<React.SetStateAction<boolean>>;
  min?: number;
}) => {
  return (
    <input
      onFocus={() => setInputFocused(true)}
      onBlur={() => {
        if (onBlur) onBlur();
        setInputFocused(false);
      }}
      autoFocus={autoFocus}
      min={min}
      style={{
        height: '1.5rem',
        lineHeight: '1rem',
        width: '100%',
        margin: '0 4px',
        marginRight: '5px',
        paddingRight: '5px',
        border: 'none',
        outline: 'none',
        color: 'rgb(128, 128, 128)',
      }}
      type="number"
      value={inputValue}
      onChange={(e) => {
        const value = Number(e.target.value);
        if (isNaN(value) || value < min) return;
        setInputValue(value);
      }}
      onKeyDown={onKeyDown}
    />
  );
};

export default NumberInput;
